/* eslint-disable no-undef */
/* eslint-disable camelcase */
if (window.publicPath) {
  __webpack_public_path__ = window.publicPath;
}
